/**
 * ==== Bootstrap Plugins ====
 * Bootstrap plugins are auto-invoked
 */
// import '@popperjs/core';  // Importiert Popper.js
// import Collapse from 'bootstrap/js/dist/collapse';
import 'bootstrap';
import Masonry from 'masonry-layout'
import imagesLoaded from 'imagesloaded';
import featherlight from 'featherlight';
 
import '../../../../../../../node_modules/featherlight/release/featherlight.gallery.min';
import '../../../../../../../node_modules/featherlight/release/featherlight.min';

/**
 * ==== Helpers on page load ====
 * - pageInit: Run some general stuff
 * - resetPage: Move footer to the bottom of the page
 */
import {resetPage, pageInit} from "./theme/reset";
// import {addWaveDivsToBody} from "./advanced-admin-script";
import { scrollHeader } from "./theme/scroll";
import {sliderConfiguration} from "./theme/sliders";
import {videoControls} from "./theme/video";
import {initRoomWatermarks} from "./theme/room-watermark";

pageInit();
resetPage();
// addWaveDivsToBody();
scrollHeader();
sliderConfiguration();
videoControls();
initRoomWatermarks();

// Mobile Navigation
(function () {
    const isMobile = () => window.innerWidth < 992;

    // Mega Menu: Mobile Accordion Toggle
    document.querySelectorAll('.navbar .dropdown > .dropdown-toggle').forEach(function (toggle) {
        toggle.addEventListener('click', function (e) {
            if (!isMobile()) return;

            const parent = this.closest('.dropdown');
            const megamenu = parent.querySelector('.megamenu, .dropdown-menu');
            if (!megamenu) return;

            e.preventDefault();
            e.stopPropagation();

            // Close sibling dropdowns
            document.querySelectorAll('.navbar .dropdown').forEach(function (dd) {
                if (dd !== parent) {
                    dd.classList.remove('show');
                }
            });

            parent.classList.toggle('show');
        });
    });

    // Mobile Nav: Logo aus .header-logo-bar klonen
    const navCollapse = document.getElementById('header-main-menu');
    if (navCollapse) {
        const logoBar = document.querySelector('.header-logo-bar');
        if (logoBar && !navCollapse.querySelector('.mobile-nav-logo')) {
            const wrapper = document.createElement('div');
            wrapper.className = 'mobile-nav-logo';
            wrapper.innerHTML = logoBar.innerHTML;
            navCollapse.prepend(wrapper);
        }

        // Body scroll lock when mobile nav is open
        navCollapse.addEventListener('show.bs.collapse', function () {
            document.body.style.overflow = 'hidden';
            document.documentElement.style.overflow = 'hidden';
        });
        navCollapse.addEventListener('hide.bs.collapse', function () {
            document.body.style.overflow = '';
            document.documentElement.style.overflow = '';
            // Close all open mega menus when nav closes
            document.querySelectorAll('.navbar .dropdown.show').forEach(function (dd) {
                dd.classList.remove('show');
            });
        });
    }

    // Reset on resize to desktop
    window.addEventListener('resize', function () {
        if (!isMobile()) {
            document.body.style.overflow = '';
            document.documentElement.style.overflow = '';
            document.querySelectorAll('.navbar .dropdown.show').forEach(function (dd) {
                dd.classList.remove('show');
            });
        }
    });
})();

// Initialize Masonry galleries after images are loaded
document.querySelectorAll('.gallery-masonry').forEach(function (grid) {
    imagesLoaded(grid, function () {
        new Masonry(grid, {
            itemSelector: '[class*="col-"]',
            percentPosition: true,
        });
    });
});

/**
 * Run functions on window-resize
 * - resetPage: Move footer to the bottom of the page
 */
window.addEventListener("resize", function () {
    resetPage();
});
